<mat-dialog-content class="dialog-content">
  <div class="profile-box info-box flex-column">
    <header class="accent flex-row-space-between-center">
      <div class="title p-8">{{ forProduct }}</div>
    </header>
  </div>

  <div class="p-8">
    <div *ngIf="choicesProduct" style="width: 100%">
      <div
        *ngFor="let product of choicesProduct; let i = index"
        class="flex-row-space-between-center choice-row"
        [class.row-even]="i % 2 === 0"
        [class.row-odd]="i % 2 !== 0"
      >
        <div class="mr-12" style="text-align: right">
          {{ product.name_internal_org }}:
        </div>
        <app-choice-combo-select
          [product]="product"
          (onSelection)="onChoiceSelection($event, product)"
        ></app-choice-combo-select>
      </div>
    </div>

    <div mat-dialog-actions class="pt-8 pb-4 flex-row-center-start">
      <button mat-raised-button (click)="onSaveChoices()" class="accent mr-16">
        {{ "GENERIC.SAVE" | translate }}
      </button>
      <button
        mat-raised-button
        color="primary"
        (click)="dialogRef.close(false)"
        class=""
      >
        {{ "GENERIC.CANCEL" | translate }}
      </button>
    </div>
  </div>
</mat-dialog-content>
